import { accountKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useApi } from '@/app/api'
import { retrying } from '@/app/retrying'
import { indexHomeAccounts } from '../internal/home-accounts.ts'

export interface UseHomeAccountsOptions {
  readonly ledgerId: () => string | undefined
  readonly enabled: () => boolean
}

export function useHomeAccounts(options: UseHomeAccountsOptions) {
  const api = useApi()
  const { locale } = useI18n()
  const active = computed(() => options.enabled() && options.ledgerId() !== undefined)

  const treeQuery = useQuery({
    queryKey: computed(() => accountKeys.tree(options.ledgerId() ?? '')),
    queryFn: ({ signal }) => api.accounts.tree(options.ledgerId()!, signal),
    enabled: active,
    retry: false,
  })

  return {
    index: computed(() => indexHomeAccounts(treeQuery.data.value ?? [], locale.value as 'en' | 'hu')),
    isLoading: computed(() => active.value && treeQuery.isPending.value),
    error: computed(() => treeQuery.error.value),
    retrying: retrying(treeQuery),
    retry: () => {
      void treeQuery.refetch()
    },
  }
}
